import { render, staticRenderFns } from "./TableBudgetEnv2.vue?vue&type=template&id=6650f838&scoped=true&"
import script from "./TableBudgetEnv2.vue?vue&type=script&lang=js&"
export * from "./TableBudgetEnv2.vue?vue&type=script&lang=js&"
import style0 from "./TableBudgetEnv2.vue?vue&type=style&index=0&id=6650f838&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6650f838",
  null
  
)

export default component.exports